// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlkb7n{flex-grow:1}\n._1bsb1osq{width:100%}\n._1o9zkb7n{flex-shrink:1}\n._4t3i1osq{height:100%}\n._i0dlf1ug{flex-basis:0%}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
